export default __webpack_public_path__ + "static/media/spr-schema-1-dark-large.a01d709e.png";